import { render, staticRenderFns } from "./Drum.vue?vue&type=template&id=4cefe503"
import script from "./Drum.vue?vue&type=script&lang=js"
export * from "./Drum.vue?vue&type=script&lang=js"
import style0 from "./Drum.vue?vue&type=style&index=0&id=4cefe503&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports